import { SUPPORTED_LANGUAGES, type WebModuleDefinition } from '@portal/web-sdk';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import vi from './vi.json';

const STORAGE_KEY = 'portal.language';

function savedLanguage(): string {
  try {
    return localStorage.getItem(STORAGE_KEY) ?? 'vi';
  } catch {
    return 'vi';
  }
}

/** Vietnamese is the source language; English falls back to it key by key. */
export function setupI18n(modules: WebModuleDefinition[]) {
  void i18n.use(initReactI18next).init({
    resources: { vi: { shell: vi }, en: { shell: en } },
    lng: savedLanguage(),
    fallbackLng: 'vi',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    defaultNS: 'shell',
    interpolation: { escapeValue: false },
  });
  for (const { manifest, translations } of modules) {
    if (!translations) continue;
    i18n.addResourceBundle('vi', manifest.key, translations.vi);
    if (translations.en) i18n.addResourceBundle('en', manifest.key, translations.en);
  }
  document.documentElement.lang = i18n.language;
  i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng;
    try {
      localStorage.setItem(STORAGE_KEY, lng);
    } catch {
      // Storage may be unavailable (private mode); the choice then lasts for this tab only.
    }
  });
  return i18n;
}
